'use client';
import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const RepositoryFolderPage = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(250px, 300px);
  gap: 50px;

  @media (max-width: ${breakPoints.tablet}) {
    grid-template-columns: minmax(0, 1fr);
    .sidebar {
      display: none;
    }
  }
`;
